import * as yup from 'yup';
import { MessageConstant } from '../MessageConstant';

export const commonCreatePermissionGroupValidation: { [x: string]: any; } = {
  tempResource: yup.array()
    .of(yup.string())
    .min(1, MessageConstant.common.STRING_ARRAY_REQUIRED),
  attributes: yup.array()
    .of(yup.string())
    .min(1, MessageConstant.common.STRING_ARRAY_REQUIRED)
};

export const commonUpdatePermissionGroupValidation: { [x: string]: any; } = {
  resource: yup.string()
    .required(MessageConstant.common.MISSING),
  attributes: yup.array()
    .of(yup.string())
    .min(1, MessageConstant.common.STRING_ARRAY_REQUIRED)
};

export const createPermissionGroupValidation: { [x: string]: any; } = {
  ...commonCreatePermissionGroupValidation,
};

export const updatePermissionGroupValidation: { [x: string]: any; } = {
  ...commonUpdatePermissionGroupValidation,
};

export const createPermissionValidationSchema = yup.object().shape(createPermissionGroupValidation);
export const updatePermissionValidationSchema = yup.object().shape(updatePermissionGroupValidation);